export default __webpack_public_path__ + "static/media/placeholder_1920x768.8cc4ef86.jpg";